import { useTranslation } from 'react-i18next';
import { ClaimCard } from 'core/enums/rewards';
import { Util } from 'utils/common.utils';
import { RewardUtils } from 'utils/reward.utils';
import styles from '../reward-details-card.module.scss';

function RewardDetailsCardImage({
  image,
  endDate,
  noOfEntries,
  achieved,
  type,
}: {
  image: string;
  endDate: Date;
  achieved?: boolean;
  noOfEntries?: number;
  type: ClaimCard;
}) {
  const topLabel = endDate && type === ClaimCard.Reward ? RewardUtils.GetTopLabel(endDate) : null;
  const showEntries = type === ClaimCard.Competition;

  const { t } = useTranslation();
  return (
    <div className="cust-mb-4 cust-mb-sm-0 flex-1">
      <div className="position-relative w-100 d-flex justify-content-center">
        {topLabel && (
          <div style={{ backgroundColor: topLabel.color }} className={`${styles.topLabel} text-label text-center`}>
            {t(topLabel.text)}
          </div>
        )}
        <div className={`${styles.imageContainer}`}>
          <img className={styles.image} src={Util.GetMediaPath(image)} alt="reward_image" />
          <div className={achieved ? styles.earnedOverlay : styles.overlay} />
          {achieved && (
            <div className={`position-absolute d-flex justify-content-center align-items-center ${styles.tickHolder}`}>
              <i className={`icon-wk-dstv-tick-in-circle ${styles.achievedTick}`} />
            </div>
          )}
        </div>
        {showEntries ? (
          <p
            className={`${styles.label} position-absolute w-100 text-center d-flex align-items-center justify-content-center gap-1`}
          >
            <i className="icon-rewards-benefit-competitions" />
            {noOfEntries ? (
              <span>{t('rewards.claim.competition.entries', { count: noOfEntries })}</span>
            ) : (
              <span>{t('rewards.competitions.notEntered')}</span>
            )}
          </p>
        ) : null}
      </div>
    </div>
  );
}
export default RewardDetailsCardImage;